import noDataFound from '../../../assets/svg/noDataFound.svg';
import CurrentlyUnavailableCard from '../../currently_unavailable_div/CurrentlyUnavailableCard';

import moment from 'moment';
import React from 'react';
void React;

const SERVICE_REQUEST_DATE_FORMATS = [
  'YYYY/MM/DD HH:mm:ss:SSS',
  moment.ISO_8601,
];

export const formatServiceRequestDate = (date) =>
  moment(date, SERVICE_REQUEST_DATE_FORMATS, true).format('DD-MMM-YYYY');

export const getHeadCells = (showCustomerId) => {
  const base = [
    {
      id: 'Request_Number',
      numeric: true,
      disablePadding: false,
      label: 'REQUEST_NUMBER',
      alignment: 'left',
      sortingEnabled: false,
      filterEnabled: false,
      width: '18%',
    },
    {
      id: 'Type',
      numeric: false,
      disablePadding: false,
      label: 'TYPE',
      alignment: 'left',
      sortingEnabled: false,
      filterEnabled: true,
      width: '18%',
    },
    {
      id: 'Date',
      numeric: false,
      disablePadding: false,
      label: 'DATE',
      alignment: 'left',
      sortingEnabled: true,
      filterEnabled: false,
      width: '18%',
    },
    {
      id: 'Status',
      numeric: false,
      disablePadding: false,
      label: 'STATUS',
      alignment: 'left',
      sortingEnabled: false,
      filterEnabled: false,
      width: '18%',
    },
  ];
  if (showCustomerId) {
    base.push({
      id: 'Customer_Id',
      numeric: true,
      disablePadding: false,
      label: 'USER_ID',
      alignment: 'left',
      sortingEnabled: false,
      filterEnabled: true,
      width: '18%',
    });
  }
  return base;
};

export const alignment = {
  Request_Number: 'left',
  Type: 'left',
  Date: 'left',
  Status: 'left',
  Customer_Id: 'left',
};

export const renderNoData = (title, subTitle) => (
  <CurrentlyUnavailableCard
    title={title}
    subTitle={subTitle}
    fullScreen={true}
    customImage={noDataFound}
  />
);

export const createFilterLists = (data) => {
  if (!data || data.length === 0) {
    return {
      Type: ['ALL'],
      Customer_Id: ['ALL'],
    };
  }
  const types = [
    ...new Set(data.map((item) => item?.Type || '').filter(Boolean)),
  ];
  const customerIds = [
    ...new Set(data.map((item) => item?.Customer_Id || '').filter(Boolean)),
  ];
  return {
    Type: ['ALL', ...types],
    Customer_Id: ['ALL', ...customerIds],
  };
};

export const createMobileFilterOptions = (serviceRequests, t) => {
  if (!serviceRequests)
    return {
      typeOptions: [{label: t('ALL'), value: 'ALL'}],
      customerIdOptions: [{label: t('ALL'), value: 'ALL'}],
    };

  const typeSet = new Set();
  const customerIdSet = new Set();

  for (const item of serviceRequests) {
    if (item.Type) typeSet.add(item.Type);
    if (item.Customer_Id) customerIdSet.add(item.Customer_Id);
  }

  return {
    typeOptions: [
      {label: t('ALL'), value: 'ALL'},
      ...Array.from(typeSet).map((type) => ({label: t(type), value: type})),
    ],
    customerIdOptions: [
      {label: t('ALL'), value: 'ALL'},
      ...Array.from(customerIdSet).map((id) => ({label: id, value: id})),
    ],
  };
};

export const mobileSortOptions = [
  {property: 'DATE', order: 'asc'},
  {property: 'DATE', order: 'desc'},
];

export const createTableConfig = (data, showCustomerId = false) => {
  const filterLists = createFilterLists(data);
  const cells = getHeadCells(showCustomerId);

  return cells.map((cell) => {
    if (cell.filterEnabled && filterLists[cell.id]) {
      return {...cell, filterList: filterLists[cell.id]};
    }
    return cell;
  });
};
